import React, { FC } from 'react';
import Image from 'next/image';
import { ImageLoaderProps } from 'next/dist/client/image-component';

type Props = {
  imageUrl: string;
  style?: any;
  onLoadingComplete?: any;
  onError?: any;
  fill?: boolean;
  alt?: string;
} & Partial<ImageLoaderProps>;

const CustomImage: FC<Props> = ({
  imageUrl,
  style,
  onLoadingComplete,
  onError,
  fill,
  alt = 'KLıC - Streaming',
  ...rest
}) => {
  // const timeStamp = new Date().getTime();

  return (
    <Image
      src={`${imageUrl}`}
      width={60}
      height={60}
      alt={alt}
      loader={(): any => {
        return `${imageUrl}`;
      }}
      loading="lazy"
      onError={onError}
      onLoadingComplete={onLoadingComplete}
      style={style}
      {...rest}
      unoptimized={true}
    />
  );
};

export default CustomImage;
